import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    quote: "Astra's Denial Agent flagged coding issues before submission that we used to catch weeks later. Our clean-claim rate climbed past 99% in the first quarter.",
    role: "Practice Administrator",
    org: "Multi-Specialty Group",
    metric: "+11% clean claims",
  },
  {
    quote: "The AI Scribe gave our physicians their evenings back. Notes are done before the patient leaves the room, and coding flows straight into billing.",
    role: "Chief Medical Officer",
    org: "Primary Care Network",
    metric: "70% less charting",
  },
  {
    quote: "We replaced four disconnected tools with one platform. Scheduling, records, billing, and telehealth finally talk to each other.",
    role: "Chief Financial Officer",
    org: "Cardiology Practice",
    metric: "33-day AR cycle",
  },
];

export const Testimonials = () => {
  return (
    <section id="testimonials" data-testid="testimonials" className="relative z-10 bg-white py-16 md:py-24 border-t border-[#D8E6F1]">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-16">
          <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-[#2880B8] mb-5">/ Proof</p>
          <h2 className="font-display text-4xl md:text-6xl font-medium tracking-tighter text-[#0C2A40] leading-[0.95]">
            Trusted by practices that <span className="font-extrabold text-[#2880B8]">measure everything.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.1, duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
              className="relative bg-[#F2F8FC] rounded-2xl border border-[#D8E6F1] p-8 flex flex-col"
            >
              <Quote size={32} className="text-[#2880B8]/30 mb-4" />
              <div className="flex gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} size={14} className="fill-[#2880B8] text-[#2880B8]" />
                ))}
              </div>
              <blockquote className="text-[#0C2A40] leading-relaxed flex-1">{`"${t.quote}"`}</blockquote>
              <figcaption className="mt-6 pt-6 border-t border-[#D8E6F1] flex items-center justify-between">
                <div>
                  <div className="font-display font-semibold text-[#0C2A40]">{t.role}</div>
                  <div className="font-mono text-[10px] tracking-[0.12em] uppercase text-[#93A5B5]">{t.org}</div>
                </div>
                <span className="font-mono text-[10px] tracking-[0.1em] uppercase text-[#2880B8] bg-[#E7F1F8] px-2 py-1 rounded-full">{t.metric}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
